export class Script {
    public static loadScript = (id: string, src: string, async = true) => {
        let scriptLoadingTask = Script.store[id];
        const existingScript = document.getElementById(id);
        if (existingScript && scriptLoadingTask) {
            return scriptLoadingTask;
        }

        scriptLoadingTask = new Promise<void>((resolve, reject) => {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.async = async;
            script.id = id;
            script.onload = () => {
                resolve();
            };
            script.onerror = (err) => {
                reject(err);
            };
            script.src = src;
            document.body.appendChild(script);
        });

        Script.store[id] = scriptLoadingTask;

        return scriptLoadingTask;
    };

    private static store: { [key: string]: Promise<void> } = {};
};
